(() => {
  if (window.jellybeanQuizCartBridgeLoaded) return;
  window.jellybeanQuizCartBridgeLoaded = true;

  const cartMutationPattern = /\/cart\/(add|change|update|clear)\.js$/;
  const cartPath = new URL(
    window.theme?.routes?.cart_url || '/cart',
    window.location.origin
  ).pathname.replace(/\/$/, '');
  let refreshTimer;
  let refreshInProgress = false;
  let refreshQueued = false;
  let shouldOpenCart = false;
  const connectedQuizCartButtons = new WeakSet();

  const getRequestDetails = (input, init = {}) => {
    const request = input instanceof Request ? input : null;
    const url = new URL(request?.url || input, window.location.origin);
    const method = (init.method || request?.method || 'GET').toUpperCase();

    return { method, url };
  };

  const isCartMutation = (input, init) => {
    try {
      const { method, url } = getRequestDetails(input, init);
      return method !== 'GET' && cartMutationPattern.test(url.pathname);
    } catch (_error) {
      return false;
    }
  };

  const openCartDrawer = () => {
    const cartButton = document.getElementById('CartButton');
    if (cartButton) cartButton.click();
  };

  const refreshCartDrawer = async () => {
    if (refreshInProgress) {
      refreshQueued = true;
      return;
    }

    refreshInProgress = true;
    const openAfterRefresh = shouldOpenCart;
    shouldOpenCart = false;

    await new Promise((resolve) => {
      let timeout;
      const finish = () => {
        window.clearTimeout(timeout);
        document.removeEventListener('shapes:cart:update', finish);
        resolve();
      };

      document.addEventListener('shapes:cart:update', finish, { once: true });
      document.dispatchEvent(new CustomEvent('theme:update:cart'));
      timeout = window.setTimeout(finish, 2500);
    });

    if (openAfterRefresh) openCartDrawer();
    refreshInProgress = false;

    if (refreshQueued || shouldOpenCart) {
      refreshQueued = false;
      refreshCartDrawer();
    }
  };

  const scheduleCartDrawerRefresh = ({ delay = 250, open = false } = {}) => {
    shouldOpenCart = shouldOpenCart || open;
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshCartDrawer, delay);
  };

  const originalFetch = window.fetch;
  window.fetch = async function jellybeanQuizCartFetch(input, init) {
    const cartMutation = isCartMutation(input, init);
    const response = await originalFetch.apply(this, arguments);

    if (cartMutation && response.ok) scheduleCartDrawerRefresh();
    return response;
  };

  const originalXhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function jellybeanQuizCartXhrOpen(
    method,
    url
  ) {
    this.jellybeanCartMutation = isCartMutation(url, { method });
    return originalXhrOpen.apply(this, arguments);
  };

  const originalXhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function jellybeanQuizCartXhrSend() {
    if (this.jellybeanCartMutation) {
      this.addEventListener(
        'load',
        () => {
          if (this.status >= 200 && this.status < 300) {
            scheduleCartDrawerRefresh();
          }
        },
        { once: true }
      );
    }

    return originalXhrSend.apply(this, arguments);
  };

  const isProceedToCartControl = (element) => {
    const label = (element.textContent || element.value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    if (/^(go|proceed|view)\s+to\s+(your\s+)?cart\b/.test(label)) return true;
    if (!(element instanceof HTMLAnchorElement) || !element.href) return false;

    const url = new URL(element.href, window.location.origin);
    return (
      url.origin === window.location.origin &&
      url.pathname.replace(/\/$/, '') === cartPath
    );
  };

  const interceptProceedToCart = (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    scheduleCartDrawerRefresh({ delay: 0, open: true });
  };

  const connectQuizCartButtons = () => {
    if (!window.quiz?.querySelectorAll) return;

    let controls;
    try {
      controls = window.quiz.querySelectorAll(
        'a[href], button, input[type="button"], input[type="submit"], [role="button"]'
      );
    } catch (_error) {
      return;
    }
    Array.from(controls || []).forEach((control) => {
      if (
        connectedQuizCartButtons.has(control) ||
        !isProceedToCartControl(control)
      ) {
        return;
      }

      connectedQuizCartButtons.add(control);
      control.addEventListener('click', interceptProceedToCart, true);
    });
  };

  document.addEventListener(
    'click',
    (event) => {
      const path = event.composedPath();
      const insideQuiz = path.some(
        (element) =>
          element instanceof Element &&
          element.hasAttribute('data-jellybean-quiz-cart-bridge')
      );
      if (!insideQuiz) return;

      const control = path.find(
        (element) =>
          element instanceof HTMLAnchorElement ||
          element instanceof HTMLButtonElement
      );
      if (control && isProceedToCartControl(control)) {
        interceptProceedToCart(event);
      }
    },
    true
  );

  connectQuizCartButtons();
  window.setInterval(connectQuizCartButtons, 500);
})();
